import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MainToolbar from '../MainToolbar';
import { t } from '../common/LocalizationProvider';
import { useEffectAsync } from '../reactHelper';
import { maintenancesActions } from '../store';
import EditCollectionView from '../EditCollectionView';
import positionAttributes from '../attributes/positionAttributes';
import { formatDistance, formatSpeed } from '../common/formatter';
import { useAttributePreference } from '../common/preferences';
import SettingsDrawer from "../shared/SettingsDrawer";

import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  CssBaseline,
  useTheme,
  useMediaQuery,
  Container
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {cyberStyles} from "../cssShared/cyberTheme";

const useTableStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const usePageStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const MaintenancesView = ({ updateTimestamp, onMenuClick }) => {
  const classes = useTableStyles();
  const speedUnit = useAttributePreference('speedUnit');
  const distanceUnit = useAttributePreference('distanceUnit');
  const dispatch = useDispatch();
  const items = useSelector((state) => Object.values(state.maintenances.items));

  useEffectAsync(async () => {
    const response = await fetch('/api/maintenance');
    if (response.ok) {
      dispatch(maintenancesActions.refresh(await response.json()));
    }
  }, [updateTimestamp]);

  const convertAttribute = (key, value) => {
    const attribute = positionAttributes[key];
    if (attribute && attribute.dataType) {
      switch (attribute.dataType) {
        case 'speed':
          return formatSpeed(value, speedUnit);
        case 'distance':
          return formatDistance(value, distanceUnit);
        default:
          return value;
      }
    }
    return value;
  }

  return (
      <TableContainer className={classes.container}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell + ' ' + classes.columnAction} />
              <TableCell className={classes.headerCell}>{t('sharedName')}</TableCell>
              <TableCell className={classes.headerCell}>{t('maintenanceId')}</TableCell>
              <TableCell className={classes.headerCell}>{t('sharedType')}</TableCell>
              <TableCell className={classes.headerCell}>{t('start')}</TableCell>
              <TableCell className={classes.headerCell}>{t('maintenancePeriod')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
                <TableRow key={item.id} className={classes.row}>
                  <TableCell className={classes.columnAction} padding="none">
                    <IconButton onClick={event => onMenuClick(event.currentTarget, item.id)}>
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell style={{ fontWeight: 500 }}>{item.name}</TableCell>
                  <TableCell style={{ color: '#00f2ff', fontFamily: 'monospace' }}>{item.id}</TableCell>
                  <TableCell>{item.type}</TableCell>
                  <TableCell>{convertAttribute(item.type, item.start)}</TableCell>
                  <TableCell>{convertAttribute(item.type, item.period)}</TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
}

const MaintenacesPage = () => {
  const classes = usePageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer
            hideDrawer={hideDrawer}
            setHideDrawer={setHideDrawer}
            page={'settings'}
        />

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} />

          <Container maxWidth="xl">
            <EditCollectionView
                content={MaintenancesView}
                editPath="/settings/maintenance"
                endpoint="maintenance"
            />
          </Container>
        </main>
      </div>
  );
}

export default MaintenacesPage;